import { Button } from "@/components/flexkit/Button";
import { Heading1 } from "@/components/podkit/typography/Headings";
import { Text } from "@/components/podkit/typography/Text";
import { Cable } from "lucide-react";
import { type FC } from "react";
import { Link } from "react-router-dom";

export const NoEnvModal: FC<{
    onClose: () => void;
}> = ({ onClose }) => {
    return (
        <div
            className="flex flex-col items-center gap-4 overflow-hidden px-5 py-4"
            data-testid="no-runner-configured-content"
        >
            <div className="flex max-w-[330px] flex-col items-center gap-4">
                <div className="flex flex-col items-center gap-4">
                    <Heading1 className="text-wrap text-center text-2xl font-bold text-content-primary">
                        You need to set up a runner before you can create environments
                    </Heading1>
                    <Cable className="size-[60px] text-content-secondary" strokeWidth={1} />
                    <Text className="text-wrap text-center text-xl text-content-secondary">
                        A runner is a service that runs your development environment. They can be set up on your local
                        machine or in the cloud.
                    </Text>
                </div>
                <Button variant="primary" className="w-full" asChild>
                    <Link
                        to="/settings/runners"
                        onClick={onClose}
                        data-testid="set-up-a-runner-link"
                        data-tracking-id="setup-runner-no-environment-modal"
                    >
                        Set up a runner
                    </Link>
                </Button>
            </div>
        </div>
    );
};
